module.exports = __webpack_public_path__ + "assets/img/Pioneer_Rochat_Cau.c4efc406-ps.jpg";